import { createContext } from "react";
import { GeneralStore } from "./general_store";

export const rootStoreContext = createContext({
  generalStore: new GeneralStore(),
});
